/* eslint-disable react-hooks/exhaustive-deps */
import AppContext from "AppContext";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PermMediaIcon from "@material-ui/icons/PermMedia";
import { getTodayRelativeDate } from "utils/dateUtils";

function MessageEventNotification({ notification }) {
    const history = useHistory();
    const { id, body, author, media, conversationAttributes, identityToNotify } = notification || {};
    const attributes = JSON.parse(conversationAttributes || "{}");
    const { clientId, clientName, originalModule, originalFileCaseId, originalFileNo } = attributes || {};
    const [authorName, setAuthorName] = useState(clientName || author);

    const {
        api: {
            Management: { Customers },
            Chat: { Notifications },
            Settings: { Users },
        },
        markCachedNotificationsAsRead,
    } = useContext(AppContext);

    function getCustomer() {
        Customers.getOneById({
            id: clientId,
            onSuccess: async (data) => {
                setAuthorName(data.fullName || clientName);
            },
            onError: (error) => {
                setAuthorName(clientName);
            },
        });
    }

    const getUser = async () => {
        const user = await Users.getOneByEmailAsync({ email: String(author).replace("|_at_|", "@") });
        if (user) {
            setAuthorName(user.name);
        }
    };

    useEffect(() => {
        if (notification) {
            if (attributes) {
                if (attributes.type === "external") {
                    getCustomer();
                } else {
                    getUser();
                }
            }
        }
    }, [notification]);

    const getNotificationDate = () => {
        const { eventType, dateCreated, dateUpdated, dateRemoved } = notification;

        switch (eventType) {
            case "onMessageAdded":
                return dateCreated;
            case "onMessageUpdated":
                return dateUpdated;
            case "onMessageRemoved":
                return dateRemoved;
            default:
                return dateCreated;
        }
    };

    const getEventName = () => {
        const { eventType } = notification;

        switch (eventType) {
            case "onMessageAdded":
                return "New message";
            case "onMessageUpdated":
                return "Message updated";
            case "onMessageRemoved":
                return "Message removed";
            default:
                return "";
        }
    };

    const onMarkAsRead = async () => {
        // Mark notification as read
        await Notifications.markNotificationsAsRead([id]);
        // Clear notifications
        markCachedNotificationsAsRead(identityToNotify, [id]);
    };

    const onClickHandler = () => {
        if (originalModule && originalFileCaseId) {
            // Redirect to chat
            history.push(`/${originalModule}?fileCaseId=${originalFileCaseId}&openTab=chat`);
        }
    };

    const onCloseClickHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onMarkAsRead(id);
    };

    return (
        <div className="notification" onClick={onClickHandler}>
            <div className="actions">
                <div className="close" onClick={onCloseClickHandler}>
                    X
                </div>
            </div>
            <div className="author-container">
                <span className="author">{authorName || author}</span>
                <span className="date">{getTodayRelativeDate(getNotificationDate())}</span>
            </div>
            {originalFileNo && (
                <div className="event-name">
                    <span>{getEventName()}</span>
                    <span>{" in "}</span>
                    <span>
                        <a href="#top" onClick={onClickHandler}>
                            {originalFileNo}
                        </a>
                    </span>
                </div>
            )}
            <p className="body">{body}</p>
            {media && (
                <div className="media-file">
                    <PermMediaIcon fontSize="small" color="action" /> <span>Contains media files</span>
                </div>
            )}
        </div>
    );
}

export default MessageEventNotification;
